/* ============================================
   STILL IN THE GAME — "Thirty-Year Knees Guarantee" product template JS
   Ported from product-page/main.js and generalised for Shopify:
   - pack prices come from data-* attributes rendered by Liquid (variant prices in cents)
   - money is formatted with the shop's money_format
   - the hidden product-form inputs (id / quantity / selling_plan) follow the selection
   - a `tykg:selection` event keeps the Offer / Final CTA price mirrors and the
     sticky bar (separate sections) in sync with the hero buy box
   ============================================ */
(function () {
  'use strict';

  /* ---------- Money ---------- */
  function formatMoney(cents, format) {
    var fmt = format || '${{amount}}';
    var amount = (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var noDec = Math.round(cents / 100).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return fmt
      .replace(/\{\{\s*amount\s*\}\}/g, amount)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, noDec)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, amount.replace('.', ','))
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, noDec);
  }

  /* Strip trailing ".00" so "$109.00" renders as "$109", matching the vanilla page. */
  function tidy(str) {
    return str.replace(/([.,])00(?!\d)/, '');
  }

  /* ---------- Buy box ---------- */
  function initBuyBox(form) {
    var moneyFormat = form.getAttribute('data-money-format') || '${{amount}}';
    var perDaySuffix = form.getAttribute('data-perday-suffix') || '/day';
    var subSuffix = form.getAttribute('data-sub-suffix') || ' · Subscription';
    var subscribe = form.querySelector('[data-tykg-subscribe]');
    var ctaPrice = form.querySelector('[data-tykg-cta-price]');
    var cta = form.querySelector('[data-tykg-cta]');
    var ctaDefault = cta ? cta.getAttribute('data-default-label') || '' : '';
    var soldOut = cta ? cta.getAttribute('data-soldout-label') || 'Sold out' : 'Sold out';
    var subDays = form.querySelectorAll('[data-tykg-sub-days]');
    var inputId = form.querySelector('input[name="id"]');
    var inputQty = form.querySelector('input[name="quantity"]');
    var inputPlan = form.querySelector('input[name="selling_plan"]');

    function money(cents) { return tidy(formatMoney(cents, moneyFormat)); }

    function update() {
      var sub = !!(subscribe && subscribe.checked);
      var radios = form.querySelectorAll('input[name="tykg-pack"]');
      var selected = null;

      radios.forEach(function (r) {
        var base = parseInt(r.getAttribute('data-price'), 10) || 0;
        var subPrice = parseInt(r.getAttribute('data-sub-price'), 10) || base;
        var days = parseInt(r.getAttribute('data-days'), 10) || 30;
        var price = sub && r.getAttribute('data-plan-id') ? subPrice : base;
        var perday = Math.round(price / days);
        var p = form.querySelector('[data-price-for="' + r.value + '"]');
        var d = form.querySelector('[data-perday-for="' + r.value + '"]');
        if (p) p.textContent = money(price);
        if (d) d.textContent = money(perday) + perDaySuffix;
        if (r.checked) {
          selected = {
            value: r.value,
            price: price,
            perday: perday,
            days: days,
            label: r.getAttribute('data-label') || '',
            variantId: r.getAttribute('data-variant-id') || '',
            planId: r.getAttribute('data-plan-id') || '',
            qty: parseInt(r.getAttribute('data-qty'), 10) || 1,
            available: r.getAttribute('data-available') !== 'false'
          };
        }
      });

      if (!selected) return;

      if (inputId) inputId.value = selected.variantId;
      if (inputQty) inputQty.value = selected.qty;
      if (inputPlan) inputPlan.value = (sub && selected.planId) ? selected.planId : '';

      var priceText = money(selected.price);
      var perdayText = money(selected.perday) + perDaySuffix;
      if (ctaPrice) ctaPrice.textContent = priceText;
      if (cta) {
        cta.disabled = !selected.available;
        var lbl = cta.querySelector('[data-tykg-cta-label]');
        if (lbl) lbl.textContent = selected.available ? ctaDefault : soldOut;
        var pw = cta.querySelector('[data-tykg-cta-pricewrap]');
        if (pw) pw.hidden = !selected.available;
      }
      subDays.forEach(function (el) { el.textContent = selected.days; });

      document.querySelectorAll('[data-tykg-cta-price-mirror]').forEach(function (el) { el.textContent = priceText; });

      window.tykgSelection = {
        label: selected.label + ((sub && selected.planId) ? subSuffix : ''),
        price: priceText,
        perday: perdayText,
        days: selected.days,
        subscribed: sub && !!selected.planId,
        available: selected.available
      };
      document.dispatchEvent(new CustomEvent('tykg:selection', {
        detail: {
          label: selected.label + ((sub && selected.planId) ? subSuffix : ''),
          price: priceText,
          perday: perdayText,
          days: selected.days,
          subscribed: sub && !!selected.planId,
          available: selected.available
        }
      }));
    }

    form.addEventListener('change', update);
    update();
  }

  /* ---------- Hero gallery: dots + thumbs follow the scroll-snap track ---------- */
  function initGallery(gallery) {
    var track = gallery.querySelector('[data-tykg-track]');
    if (!track) return;
    var slides = Array.prototype.slice.call(track.children);
    var dots = Array.prototype.slice.call(gallery.querySelectorAll('[data-tykg-dots] button'));
    var thumbs = Array.prototype.slice.call(gallery.querySelectorAll('[data-tykg-thumbs] button'));
    var setActive = function (i) {
      dots.forEach(function (d, j) { d.classList.toggle('is-active', j === i); });
      thumbs.forEach(function (t, j) { t.classList.toggle('is-active', j === i); });
    };
    var go = function (i) {
      if (!slides[i]) return;
      track.scrollTo({ left: slides[i].offsetLeft, behavior: 'smooth' });
    };
    dots.forEach(function (d, i) { d.addEventListener('click', function () { go(i); }); });
    thumbs.forEach(function (t, i) { t.addEventListener('click', function () { go(i); }); });
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (e.isIntersecting) setActive(slides.indexOf(e.target)); });
      }, { root: track, threshold: 0.6 });
      slides.forEach(function (s) { io.observe(s); });
    }
  }

  /* ---------- Reviews row (Javvy — Reviews collage): dots follow the scroll-snap track ---------- */
  /* Cards are narrower than the viewport, so the gallery's 0.6 IntersectionObserver never settles on
     the last ones; track the card nearest the snap edge instead. The track is position:relative, so
     card.offsetLeft is measured from the track and the first card sits at the track's padding-left. */
  function initReviewRow(row) {
    var track = row.querySelector('[data-tykg-track]');
    var dotsWrap = row.querySelector('[data-tykg-dots]');
    if (!track || !dotsWrap) return;
    var cards = Array.prototype.slice.call(track.children);
    var dots = Array.prototype.slice.call(dotsWrap.querySelectorAll('button'));
    if (!cards.length || !dots.length) return;
    var padLeft = function () { return parseFloat(getComputedStyle(track).paddingLeft) || 0; };
    var setActive = function (i) {
      dots.forEach(function (d, j) { d.classList.toggle('is-active', j === i); });
    };
    var go = function (i) {
      if (!cards[i]) return;
      track.scrollTo({ left: cards[i].offsetLeft - padLeft(), behavior: 'smooth' });
    };
    dots.forEach(function (d, i) { d.addEventListener('click', function () { go(i); }); });
    var ticking = false;
    var sync = function () {
      ticking = false;
      var pad = padLeft();
      var max = track.scrollWidth - track.clientWidth;
      var best = 0, bestDist = Infinity;
      cards.forEach(function (c, i) {
        var d = Math.abs(c.offsetLeft - pad - track.scrollLeft);
        if (d < bestDist) { bestDist = d; best = i; }
      });
      if (max > 0 && track.scrollLeft >= max - 2) best = cards.length - 1;
      setActive(best);
    };
    track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(sync);
    }, { passive: true });
    /* No dots when every card already fits (wide desktop with few cards) */
    var fits = function () { dotsWrap.classList.toggle('is-static', track.scrollWidth <= track.clientWidth + 2); };
    if ('ResizeObserver' in window) { new ResizeObserver(fits).observe(track); } else { window.addEventListener('resize', fits); }
    fits();
  }

  /* ---------- Sticky bar (mobile): text follows the selection, shows once the hero CTA scrolls away ---------- */
  function initStickyBar(bar) {
    var label = bar.querySelector('[data-tykg-sticky-label]');
    var price = bar.querySelector('[data-tykg-sticky-price]');
    var perday = bar.querySelector('[data-tykg-sticky-perday]');

    function apply(d) {
      if (!d) return;
      if (label && d.label) label.textContent = d.label;
      if (price && d.price) price.textContent = d.price;
      if (perday && d.perday) perday.textContent = d.perday;
    }
    document.addEventListener('tykg:selection', function (e) { apply(e.detail); });
    apply(window.tykgSelection);

    var cta = document.querySelector('[data-tykg-cta]');
    if (!cta || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      var visible = entries[0].isIntersecting;
      var above = entries[0].boundingClientRect.top < 0;
      var show = !visible && above;
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
    }, { threshold: 0 });
    io.observe(cta);
  }

  /* ---------- Mobile nav drawer ---------- */
  function initNav(drawer) {
    var overlay = document.querySelector('.tykg-drawer-overlay');
    var burger = document.querySelector('[data-tykg-drawer-open]');
    var open = false;

    function setOpen(next) {
      open = next;
      drawer.classList.toggle('is-open', next);
      drawer.setAttribute('aria-hidden', next ? 'false' : 'true');
      drawer.inert = !next; // closed drawer: links leave the tab order
      if (overlay) overlay.classList.toggle('is-open', next);
      if (burger) burger.setAttribute('aria-expanded', next ? 'true' : 'false');
      document.body.style.overflow = next ? 'hidden' : '';
      if (next) {
        var first = drawer.querySelector('.tykg-drawer__close');
        if (first) first.focus();
      } else if (burger) {
        burger.focus();
      }
    }

    if (burger) burger.addEventListener('click', function () { setOpen(true); });

    document.querySelectorAll('[data-tykg-drawer-close]').forEach(function (el) {
      el.addEventListener('click', function () { setOpen(false); });
    });

    /* Bound to the drawer, not document, so the scroll lock is released before
       the document-level anchor handler runs its smooth scroll. */
    drawer.addEventListener('click', function (e) {
      if (e.target.closest('a[href]')) setOpen(false);
    });

    document.addEventListener('keydown', function (e) {
      if (open && (e.key === 'Escape' || e.key === 'Esc')) setOpen(false);
    });
  }

  /* ---------- Smooth in-page anchors (#buy etc.) ---------- */
  function initAnchors() {
    document.addEventListener('click', function (e) {
      var a = e.target.closest('a[href^="#"]');
      if (!a || !a.closest('.tykg')) return;
      var id = a.getAttribute('href').slice(1);
      if (!id) return;
      var target = document.getElementById(id);
      if (!target) return;
      e.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }

  function once(sel, fn) {
    document.querySelectorAll(sel).forEach(function (el) {
      if (el.getAttribute('data-tykg-init')) return;
      el.setAttribute('data-tykg-init', '1');
      fn(el);
    });
  }

  var anchorsReady = false;
  function boot() {
    once('[data-tykg-stickybar]', initStickyBar);
    once('[data-tykg-gallery]', initGallery);
    once('[data-tykg-reviewrow]', initReviewRow);
    once('[data-tykg-buyform]', initBuyBox);
    once('[data-tykg-drawer]', initNav);
    if (!anchorsReady) { anchorsReady = true; initAnchors(); }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  /* Re-init when the theme editor re-renders a section. */
  document.addEventListener('shopify:section:load', boot);
})();
